import { render } from "./EventCreate.vue?vue&type=template&id=47c9fc78&scoped=true"
import script from "./EventCreate.vue?vue&type=script&lang=js"
export * from "./EventCreate.vue?vue&type=script&lang=js"

import "./EventCreate.vue?vue&type=style&index=0&id=47c9fc78&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-47c9fc78"

export default script